// original: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/a3074a0a75dfbdb23ad52e6a2e9a41799014b3b1/static/js/team/operators/getTeamContainsFreeUsers.ts

import { getUsers, isTeamUserRoutable } from './getters';
export const getTeamContainsFreeUsers = team => {
  const users = getUsers(team);
  return users.some(user => !isTeamUserRoutable(user));
};